export const tagAbbreviations: { [key: string]: string } = {
  // Pitch results
  InPlay: "In Play",
  StrikeSwinging: "Strike",
  StrikeCalled: "Strike",
  BallCalled: "Ball",
  Foul: "Foul",
  FoulTip: "Foul Tip",
  HitByPitch: "HBP",
  CatchersInt: "Interference",
  
  // Play results
  Out: "Out",
  Sacrifice: "SAC",
  Single: "1B",
  Double: "2B",
  Triple: "3B",
  HomeRun: "HR",
  Error: "ROE",
  FieldersChoice: "FC",
  StrikeoutSwinging: "K",
  StrikeoutLooking: "ꓘ",
  Walk: "BB",
  
  // Pitch types
  Fastball: "Fastball",
  Sinker: "Sinker",
  Cutter: "Cutter",
  Changeup: "Changeup",
  Curveball: "Curveball",
  Slider: "Slider",
  Splitter: "Splitter",
  Knuckleball: "Knuckle",
  Dropball: "Dropball",
  Riseball: "Riseball",
  Screwball: "Screwball",
  LowRise: "LowRise",
  DropCurve: "DropCurve",
  
  // Contact types
  GroundBall: "GB",
  LineDrive: "LD",
  FlyBall: "Fly",
  Popup: "Pop",
  Bunt: "Bunt",
  Throwdown: "Thw",
};
